import type { IApiResponsePaged } from "@azm/core/interfaces/response";

export function toDirectPagedResponse<T>(event: object): IApiResponsePaged<T> | null {
	if (!("pageNumber" in event) || "statusCode" in event) {
		return null;
	}

	const paged = event as IApiResponsePaged<T>;
	return {
		data: paged.data,
		pageNumber: paged.pageNumber,
		pageSize: paged.pageSize,
		totalCount: paged.totalCount,
	};
}
